import { useTheme } from '@mui/styles';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    employeeMainData: {
      display: 'flex',
    },
    infoIconButton: {
      padding: 0,
      marginLeft: theme.spacing(),

      '& svg': {
        fontSize: 20,
      },
    },
    myExtraHoursBalance: {
      display: 'flex',
      justifyContent: 'space-between',
      fontWeight: theme.typography.fontWeightBold,
      marginBottom: theme.spacing(),
    },
    myExtraHoursBalanceTitle: {
      overflow: 'hidden',
      marginRight: theme.spacing(),
    },
    addAbsentTodayContainer: {
      marginTop: theme.spacing(),
      marginBottom: theme.spacing(),
    },
    timeManagementTitle: {
      fontWeight: theme.typography.fontWeightBold,
      marginTop: theme.spacing(),
      marginBottom: theme.spacing(0.5),
      borderTop: '3px solid #e0e0e0',
      paddingTop: theme.spacing(1),
    },
    root: {
      overflow: 'unset',
    },
  };
};
